import { AttachmentLinkFormDataSchema } from "shared/types/AttachmentLinkFormData"

import { MAX_LENGTH_CLARIFICATION_REQUEST } from "entities/clarification-requests/types/ClarificationRequest"
import { FloorSchema } from "entities/floors/types/Floor"
import z from "zod"

export const FloorFormDataSchema = z.object({
  floor: FloorSchema.extend({
    id: FloorSchema.shape.id.nullish().optional()
  }),
  parentID: z.string(),
  projectID: z.string(),
  displayPosition: z.number(),
  roomIDs: z.array(z.string()).optional().nullable(),
  clarificationRequest: z
    .object({
      content: z
        .string()
        .max(MAX_LENGTH_CLARIFICATION_REQUEST)
        .nullable()
        .optional()
    })
    .nullable()
    .optional(),
  attachments: AttachmentLinkFormDataSchema.nullable().optional()
})

export type FloorFormData = z.infer<typeof FloorFormDataSchema>
